import { z } from 'zod'

export const schemaFormInsertarEspecie = z.object({
    especie: z.string()
})

export type FormInsertarEspecie = z.infer<typeof schemaFormInsertarEspecie>
